import { useState } from "react";
import useAuthStore from "../../../store/authStore";
import { verifyMfa } from "../service/auth_service";
import { useNavigate } from "react-router-dom";

const OtpForm = () => {
  const userid = useAuthStore((state)=> state.user);
  const inputuser = useAuthStore((state)=> state.inputUserName);
  const setToken = useAuthStore((state)=> state.setToken);
  const setUser = useAuthStore((state) => state.setUser);
  const setError = useAuthStore((state) => state.setError);
  const setShowMfaImage = useAuthStore((state) => state.setShowMfaImage);
  const requireMfa = useAuthStore((state) => state.requireMfa);
  const setDisplayUserName = useAuthStore((state)=> state.setDisplayUserName);
  const setUserLastLogin = useAuthStore((state)=> state.setUserLastLogin);
  const error = useAuthStore((state) => state.error);
  const [inputOtp, setInputOtp] = useState("");
  const navigate = useNavigate();
  const getPostLoginRoute = (roleId) => (Number(roleId) === 1 ? "/AdminContact" : `/Asset/Overview/${btoa(userid)}`);

  const handleMfaVerification = async() => {
    try{
      if (!userid || !inputuser) {
        setError("Session expired. Please login again.");
        navigate("/");
        return;
      }

      const response = await verifyMfa({
        userId: Number(userid),
        authKey: inputuser,
        authToken: String(inputOtp || "").trim(),
      });

      const data = response?.data || {};
      const status = (data.status ?? data.Status ?? "").toString().toUpperCase();
      const token = data.token ?? data.Token ?? data.jwtToken ?? data.accessToken;
      const userId = data.userId ?? data.UserId;
      const roleId = data.roleId ?? data.RoleId;
      const categoryId = data.categoryId ?? data.CategoryId;
      const showMfaImage = data.showMFAImage ?? data.ShowMFAImage;
      const displayName = data.displayName ?? data.DisplayName;
      const lastLogin = data.lastLogin ?? data.LastLogin;
      const message = data.message ?? data.Message;

      const isInvalidStatus = status.startsWith("INVALID");
      const isSuccessStatus = status === "SUCCESS";
      if ((token && !isInvalidStatus) || (isSuccessStatus && token)) {
        setToken(token);
        setShowMfaImage(showMfaImage);
        requireMfa(false);
        setUser({
          userid: userId,
          roleid: roleId,
          categoryid: categoryId
        })
        setError("");
        setDisplayUserName(displayName || "");
        setUserLastLogin(lastLogin || null);
        navigate(getPostLoginRoute(roleId));
      } else {
        setError(message || "Invalid authentication code.");
        setInputOtp("");
      }
    }
    catch{
      setError("MFA verification failed.");
    }
  }
  return (
    <form
      className="otp-form"
      onSubmit={(e) => {
        e.preventDefault();
        handleMfaVerification();
      }}
    >
      <div className="form-group">
        <label htmlFor="otpCode">Enter Code</label>
        <input
          type="text"
          id="otpCode"
          name="otpCode"
          className="otp-input"
          placeholder="Authentication Code"
          value={inputOtp}
          onChange={(e)=>setInputOtp(e.target.value)}
          required
        />
      </div>

      <div className="form-group">
        <button type="submit" className="btn1" style={{ padding: "4px" }}>
          Verify
        </button>
      </div>

      {error && (
        <div className="form-group" style={{ marginTop: 8, color: "#c72c2c" }}>
          {error}
        </div>
      )}
    </form>
  );
};

export default OtpForm;
